<template>
<div class="info">
	<div class="title">保障信息</div>
	<Form :label-width="125" ref="form" class="mt15">
		<template>
			<FormItem label="保障类型：" class="w600">1个月</FormItem>
			<FormItem label="保险起期：" class="w600">{{info.beginDate}}</FormItem>
			<FormItem label="保险止期：" class="w600">{{info.endDate}}</FormItem>
			<FormItem label="保障方案：" class="w600">{{info.insurancePlanName}}</FormItem>
		</template>
	</Form>
	<div class="recognize-table mt10 pb20">
		<Table class="mt10" ref="table" :data="pageData" border :columns="columns" style="width: 100%"></Table>
		<!-- 分页组件 -->
		<div class="pagination-container" v-if="info && info.users && info.users.length > pageSize">
			<Page 
				:total="info.users.length" 
				:current="currentPage" 
				:page-size="pageSize"
				@on-change="handlePageChange"
				show-total
				@on-page-size-change="handlePageSizeChange"
			/>
		</div>
	</div>
</div>
</template>
<script>
export default {
	props:{
		info:Object
	},
	data () {
		return {
			columns: [
				{
					title: '姓名',
					key: 'name',
					minWidth: this.$columnW.M
				},
				{
					title: '身份证号',
					key: 'idNo',
					minWidth: this.$columnW.L
				},
				{
					title: '性别',
					key: 'genderName',
					minWidth: this.$columnW.M
				},
				{
					title: '年龄',
					key: 'age',
					minWidth: this.$columnW.M
				},
				{
					title: '保费(元)',
					key: 'premium',
					width: this.$columnW.L,
					align:'right',
					render: (h, params) => {
						return h('span', params.row.premium || '-');
					}
				}
			],
			// 分页相关
			currentPage: 1,
			pageSize: 10
		}
	},
	computed:{
		// 分页数据
		pageData() {
			if (!this.info || !this.info.users) {
				return [];
			}
			const start = (this.currentPage - 1) * this.pageSize;
			const end = start + this.pageSize;
			return this.info.users.slice(start, end);
		}
	},
	methods: {
		// 分页相关方法
		handlePageChange(page) {
			this.currentPage = page;
		},
		handlePageSizeChange(pageSize) {
			this.pageSize = pageSize;
			this.currentPage = 1;
		}
	}
}
</script>
<style scoped lang="less">
	.info{
		margin-top:10px;
	}
	.title-a{
		font-size: 14px;
		margin-left: 15px;
	}
	.pb20{
		padding-bottom: 20px;
	}
    .correctUrlItem{
        margin-right: 20px;
        text-align: center;
		a{
			font-size: 12px;
			// display: block;
            margin-right: 5px;
		}
    }
	.subtitle {
		color: #FF9900;
		font-size: 16px;
		margin-left: 20px;
	}
	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/recognizeInfo.vue